import { useState } from 'react';
import useApiSubmit from '@/hooks/useApiSubmit';
import useProfile from '@/hooks/useProfileV2';
import reactionsApi, { AddReactionParams } from '@/services/reactions';
import { TReaction } from '@/types/api';
import ReactionsComponent from './Reactions.component';

type ReactionsType = {
  commentId?: string;
  answerId?: string;
  feedbackId?: string;
  reactions?: TReaction[];
  refetchCheckin: () => void;
};

const Reactions = function ({
  reactions,
  commentId,
  answerId,
  feedbackId,
  refetchCheckin,
}: ReactionsType): JSX.Element {
  const { profile } = useProfile();

  const addReactionMutation = useApiSubmit<void, AddReactionParams>(reactionsApi.addReaction);

  const removeReactionMutation = useApiSubmit<void, string>(reactionsApi.removeReaction);

  const [isShowingEmojiPicker, setIsShowingEmojiPicker] = useState(false);

  const toggleEmojiPickerVisibility = (): void => {
    setIsShowingEmojiPicker((prev) => !prev);
  };

  const onAddNewReaction = async (emoji: string): Promise<void> => {
    const payload = {
      ...(commentId && { commentId }),
      ...(answerId && { answerId }),
      ...(feedbackId && { feedbackId }),
      emoji,
    };
    await addReactionMutation.mutateAsync(payload);

    refetchCheckin();
  };

  const onRemoveReaction = async (reactionId: string): Promise<void> => {
    await removeReactionMutation.mutateAsync(reactionId);

    refetchCheckin();
  };

  return (
    <ReactionsComponent
      currentUserId={profile.id || ''}
      reactions={reactions}
      onAddNewReaction={onAddNewReaction}
      onRemoveReaction={onRemoveReaction}
      toggleEmojiPickerVisibility={toggleEmojiPickerVisibility}
      isShowingEmojiPicker={isShowingEmojiPicker}
    />
  );
};

export default Reactions;
